<!--
센터별 안내사항 변경 컴포넌트
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-3-4">

            <div class="uk-modal-header">
                <h4>센터별 이용안내 작성</h4>
            </div>

            <div class="uk-modal-body uk-padding-small">
                <!-- 에디터 -->
                <app-jodit
                    ref="jodit"
                    :init-value="centerNotice"
                    :options="{readonly: true}"
                ></app-jodit>
            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            /**
             * csrf token
             */
            csrfToken: {
                type: String,
                required: true,
            },


        },
        data: function () {
            return {

                /**
                 * (integer)
                 */
                regionId: null,

                /**
                 * (string) 글내용
                 */
                centerNotice: null,


            };
        },
        computed: {

        },
        methods: {
            /**
             * 입력폼 display
             */
            show() {
                UIkit.modal(this.$el).show();

                // 에디터 옵션변경
                let editor = this.$refs.jodit.getJodit();
                editor.setReadOnly(false);

                // 내용 초기화
                this.$refs.jodit.setEditorValue(this.centerNotice);
            },

            /**
             * 폼
             * @param region_id 고객문의ID
             */
            form(region_id) {
                this.regionId = region_id;

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/regions/' + this.regionId + '/configs/center_notice',
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.centerNotice = response.center_notice;

                    // 폼띄우기
                    this.show();
                });
            },

            /**
             * submit
             */
            submit() {

                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/regions/' + this.regionId + '/configs/center_notice',
                    data: {
                        '_token': this.csrfToken,
                        'center_notice': this.$refs.jodit.getEditorValue(),
                    },
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>